import Vue from 'vue'
import App from './app.vue'
import '@/assets/css/base.less'
import { PCResize, getTerminal } from '@/assets/js/common'

Vue.config.productionTip = false
export default new Vue({
  render: h => h(App),
  created() {
    console.log('移动端', getTerminal())
    if (['ios', 'android'].includes(getTerminal())) {
      PCResize()
    } else {
    }
  },
  mounted() {
    // 根据是否PC，换登录容器
  }
}).$mount('#app')
